import React from "react";

export default function AppHeader({
  title,
  subtitle,
  session,
  onLogout,
  logoUrl
}) {
  return (
    <header className="timecard-header">
      <div className="header-brand">
        <img className="brand-logo" src={logoUrl} alt="Meditec Staffing Company" />
        <div className="header-copy">
          {/* <span className="app-kicker">
            {session?.role === "admin" ? "Admin portal" : "Contractor portal"}
          </span> */}
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>
      </div>

      <div className="header-user-controls">
        <div className="session-chip">
          <strong>{session?.displayName}</strong>
        </div>
        <button type="button" className="secondary-action header-sign-out" onClick={onLogout}>
          Sign out
        </button>
      </div>
    </header>
  );
}
